import React from 'react';

import { useExtensionRequestsReportCsv } from 'api';
import { useExtensionRequestsFilters } from './hooks';
import { MobileReportModal } from '../..';

export const ExtensionRequestsReportMobile: React.FC = () => {
  const filters = useExtensionRequestsFilters();
  const { mutate: exportCsv } = useExtensionRequestsReportCsv();

  return <MobileReportModal filters={filters} exportCsv={exportCsv} />;
};
